/*
 * @Description: 请填写简介
 */

import { HasReachLimit } from '@/api';

/**
 * 业务场景
 */
export enum BusinessScene{
  // 链接异常(包含链接参数不完整、链接参数错误两种情况)
  ERROR_LINK = 'errorLink',

  // 通用营销场景
  COMMON_MARKETINGS = 'commonMarketings',

  // 小鹅快收 - 收款人视角场景
  QUICK_RECEIPT_RECEIVER = 'quickReceiptReceiver',

  // 小鹅快收 - 汇款人视角场景
  QUICK_RECEIPT_REMITTER = 'quickReceiptRemitter'
}

/**
 * 平台
*/
export enum PlatformType{
  PC = 'pc',
  MOBILE_INSIDE_WX = 'mobileInsideWx',
  MOBILE_OUTSIDE_WX = 'mobileOutsideWx',
}

/**
 * PC端中转页组件
*/
export enum PcBusinessComponent{
  LOGO = 'logo',
  LOGO_TITLE = 'logoTitle',
  MAIN_TEXT = 'mainText',
  COPY_LINK = 'copyLink',
  SUB_TEXT = 'subText',
  MINI_APP_QRCODE = 'miniAppQrCode'
}

/**
 * 移动端中转页组件
*/
export enum MobileBusinessComponent{
  LOGO = 'logo',
  LOGO_TITLE = 'logoTitle',
  MAIN_TEXT = 'mainText',
  MINI_APP_QRCODE = 'miniAppQrCode',
  JUMP_BUTTON = 'jumpButton',
  SUB_TEXT = 'subText',
  COPY_LINK = 'copyLink'
}

export enum JumpButtonType{
  OPEN = 'open',
  URL_SCHEME_BUTTON = 'urlSchemeButton'
}

/**
 * PC端组件所需的属性
*/
export type PcBusinessComponentInfoMap= {
  [PcBusinessComponent.LOGO]: string,
  [PcBusinessComponent.LOGO_TITLE]: string,
  [PcBusinessComponent.MAIN_TEXT]: string,
  [PcBusinessComponent.MINI_APP_QRCODE]?: string,
  [PcBusinessComponent.SUB_TEXT]?: string,
  [PcBusinessComponent.COPY_LINK]?: string
};

/**
 * 移动端组件所需的属性
*/
export type MobileBusinessComponentInfoMap= {
  [MobileBusinessComponent.LOGO]: string,
  [MobileBusinessComponent.LOGO_TITLE]: string,
  [MobileBusinessComponent.MAIN_TEXT]: string,
  [MobileBusinessComponent.MINI_APP_QRCODE]: string,
  [MobileBusinessComponent.JUMP_BUTTON]: {
    // 跳转按钮类型：开放标签 or urlScheme按钮
    buttonType: JumpButtonType
    // 开放标签使用的path
    path?: string,
    // urlScheme
    urlScheme?: string
  } | null,
  [MobileBusinessComponent.SUB_TEXT]?: string,
  [MobileBusinessComponent.COPY_LINK]?: string
};

// 场景配置类型
export type SceneConfigMapType<MapType extends (MobileBusinessComponentInfoMap | PcBusinessComponentInfoMap)> =
 Record<BusinessScene, ComponentStrategyMapType<MapType>>;

// 策略执行函数类型
export type ComponentStrategyFuncType<
  MapType extends MobileBusinessComponentInfoMap | PcBusinessComponentInfoMap,
  ComponentKey extends keyof MapType
> =
 (
   (getSceneParamsType: GetSceneParamsType) => MapType[ComponentKey]
   | (() => MapType[ComponentKey])
 );

/**
 * 组件策略类型
 * 1、直接配置返回组件所需信息
 * 2、调用函数返回组件所需信息
*/
type ComponentStrategyType<
  MapType extends MobileBusinessComponentInfoMap | PcBusinessComponentInfoMap,
  ComponentKey extends keyof MapType
> =
MapType[ComponentKey] |ComponentStrategyFuncType<MapType, ComponentKey>;

// 组件策略Map类型
export type ComponentStrategyMapType<MapType extends (MobileBusinessComponentInfoMap | PcBusinessComponentInfoMap)> = {
  [ComponentKey in keyof MapType]:
  ComponentStrategyType<MapType, ComponentKey>
};

// 业务侧传入的中转页参数类型
export type GetSceneParamsType = {

  // 平台（PC、微信端内、微信端外）
  platform: PlatformType

  // 业务场景
  businessScene: BusinessScene

  // 是否超限
  hasReachLimit: HasReachLimit

  // 开放标签path
  openPath?: string

  // urlScheme
  urlScheme?: string

  // 复制区域链接
  copyLink?: string

};
